interface DeleteIconProps {
  className?: string
}

export const DeleteIcon: React.FC<DeleteIconProps> = ({
  className = "text-redLight",
}) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_945_20478)">
      <path
        d="M38.3977 12.1921C39.1682 10.2785 39.1471 8.13722 38.3388 6.23922C37.5306 4.34123 36.0015 2.84204 34.0879 2.07147C32.1743 1.30089 30.033 1.32205 28.135 2.13029C26.237 2.93853 24.7378 4.46763 23.9672 6.38123M28.277 6.38123L23.4346 6.38123L23.4346 1.5388"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.48169 15.2166H28.4817"
        stroke="currentColor"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.606 21.9656V32.0906"
        stroke="currentColor"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3584 21.9656V32.0906"
        stroke="currentColor"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.17041 15.2166L4.85791 35.4666C4.85791 36.3617 5.21349 37.2201 5.84642 37.853C6.47936 38.486 7.3378 38.8416 8.23291 38.8416H21.7329C22.628 38.8416 23.4865 38.486 24.1194 37.853C24.7523 37.2201 25.1079 36.3617 25.1079 35.4666L26.7954 15.2166"
        stroke="currentColor"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.92017 15.2166V10.1541C9.92017 9.7065 10.098 9.27728 10.4144 8.96081C10.7309 8.64434 11.1601 8.46655 11.6077 8.46655H18.3577C18.8052 8.46655 19.2344 8.64434 19.5509 8.96081C19.8674 9.27728 20.0452 9.7065 20.0452 10.1541V15.2166"
        stroke="currentColor"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_945_20478">
        <rect
          width="40"
          height="40"
          fill="currentColor"
          transform="translate(0.5 -0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>
)
